export default __webpack_public_path__ + "static/media/bottles-card.1ce4e891.png";